var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { KompisElement, property } from '@inter-ikea-kompis/web-component';
import CollapsibleStyle from './CollapsibleStyle.js';
/**
 * This component collapse and open content with a transition.
 *
 * @event animationEnd When area has been fully expanded or fully collapsed
 */
export default class Collapsible extends KompisElement {
    constructor() {
        super(...arguments);
        // Open state. true => height 0. false => size of its content
        this.expanded = false;
        // If true, it will expand horizontally instead of vertically
        this.horizontal = false;
        this.isAnimationCompleted = true;
        this.listeners = {
            animationend: this.onAnimationEnd.bind(this)
        };
        this.elements = {
            slot: document.createElement('slot'),
            container: document.createElement('div'),
            style: document.createElement('style')
        };
        this.isRendered = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.elements.container.classList.add('container');
        this.elements.container.appendChild(this.elements.slot);
        this.shadowRoot?.appendChild(this.elements.style);
        this.shadowRoot?.appendChild(this.elements.container);
        this.elements.container.addEventListener('animationend', this.listeners.animationend);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.isRendered = false;
        this.removeEventListener('animationend', this.listeners.animationend);
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has('expanded') && this.isRendered) {
            this.isAnimationCompleted = false;
        }
        if (changedProperties.has('expanded')) {
            this.elements.container.appendChild(this.elements.slot);
        }
        this.isRendered = true;
        this.updateStyles();
        return false;
    }
    /**
     * Update CSS code in the style tag.
     */
    updateStyles() {
        this.elements.style.innerHTML = CollapsibleStyle.getStyle({
            isAnimationCompleted: this.isAnimationCompleted,
            expanded: this.expanded,
            horizontal: this.horizontal,
            contentSize: this.horizontal
                ? this.elements.container.scrollWidth
                : this.elements.container.scrollHeight
        });
    }
    /**
     * Callback for animationend.
     */
    onAnimationEnd() {
        this.isAnimationCompleted = true;
        this.updateStyles();
        if (!this.expanded) {
            this.elements.container.removeChild(this.elements.slot);
        }
        this.dispatchEvent(new CustomEvent('animationEnd', { bubbles: true }));
    }
}
__decorate([
    property({ type: Boolean })
], Collapsible.prototype, "expanded", void 0);
__decorate([
    property({ type: Boolean })
], Collapsible.prototype, "horizontal", void 0);
//# sourceMappingURL=Collapsible.js.map